import React, { useContext, useEffect, useState } from 'react'
import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CTable,
  CTableHead,
  CTableRow,
  CTableBody,
  CTableDataCell,
  CModalHeader,
  CFormCheck,
} from '@coreui/react'
import CustomDescriptionBox from 'src/components/CustomDescriptionBox'
import ImageUploader from 'src/components/ImageUploader/ImageUploader'
import AttachLink from '../attachLink'
import { GlobalContext } from 'src/views/context/GlobalState'
import { getThumbnail, validateLink } from 'src/views/utils/helper'
import Loading from 'react-fullscreen-loading'
import { AppContext } from 'src/views/context/app'
import useAxios from 'axios-hooks'
import { SYSTEM_METADATA_API } from 'src/views/utils/urls'
import TemplateAccordion from '../templateAccordion'
import { isEmpty } from 'lodash'

const FitnessHeroCardModal = ({
  cancelCardModal,
  slidesData,
  setSlidesData,
  isEdit,
  singleSlideData,
  setSingleSlideData,
  editCardIndex,
}) => {
  const { userSessionObj } = useContext(GlobalContext)
  const { loader, setLoader } = useContext(AppContext)
  const [imageS3key, setImageS3key] = useState('')
  const [content, setContent] = useState({
    heading: '',
    sub_heading: '',
    position: 'CENTER',
  })
  const [ctaButton, setCtaButton] = useState({
    enabled: true,
    text: '',
    // position: 'CENTER',
  })
  const [link, setLink] = useState({ type: '', data: {} })
  const [errorData, setErrorData] = useState({})
  const [imageData, setImageData] = useState([])
  const [{ data: categoryList, loading: categoryListLoading }] = useAxios({
    url: SYSTEM_METADATA_API,
    method: 'get',
  })

  useEffect(() => {
    setLoader(categoryListLoading)
  }, [categoryListLoading])

  useEffect(() => {
    const imgData = [
      {
        title: '',
        id: 'mdImage',
        width: 1920,
        height: 802,
        divwidth: '15.2rem',
        divheight: '8rem',
        assetId: '',
        setAssetId: (id) => {},
        setImage: (obj) => {
          clearError('imageS3key')
          setImageS3key(obj?.s3Key)
        },
        onRemoveImg: () => {
          setImageS3key('')
        },
        imageUrl: '',
        imagePaddingX: '7px',
        imagePaddingY: '7px',
      },
    ]

    if (isEdit) {
      let tempdata = singleSlideData
      if (!isEmpty(singleSlideData)) {
        setContent((prevContent) => ({
          ...prevContent,
          heading: tempdata.content.heading,
          sub_heading: tempdata.content.sub_heading,
          position: tempdata.content.position,
        }))
        setCtaButton((prevBtn) => ({
          ...prevBtn,
          enabled: tempdata.cta_button.enabled,
          text: tempdata.cta_button.text,
          position: tempdata.cta_button.position,
        }))
        setImageS3key(tempdata.image_s3key)
        imgData[0]['assetId'] = tempdata.image_s3key
        imgData[0]['imageUrl'] = getThumbnail(
          userSessionObj?.session_data?.cf_domain_name,
          tempdata.image_s3key,
        )
        setLink(tempdata.link)
      }
    }

    setImageData(imgData)
  }, [])

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (imageS3key.trim().length === 0) {
      isFormValid = false
      temp.imageS3key = 'Upload Image!'
    }

    if (ctaButton.enabled && ctaButton.text.trim().length === 0) {
      isFormValid = false
      temp.ctaButtonText = 'CTA Button Text Cannot be Empty!'
    }

    if (link.type && !validateLink(link).isValid) {
      isFormValid = false
      temp.link = validateLink(link).error
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  const clearError = (type) => {
    let temp = errorData
    temp[`${type}`] = ''
    setErrorData({ ...temp })
  }

  const handleSave = () => {
    if (!validateInfo()) return

    let elementObj = {
      image_s3key: imageS3key,
      content: content,
      cta_button: ctaButton,
      link: link,
    }
    if (isEdit) {
      let slides = [...slidesData]
      slides[editCardIndex] = elementObj
      setSlidesData(slides)
      setSingleSlideData({})
    } else {
      setSlidesData((slidesData) => [...slidesData, elementObj])
      setSingleSlideData({})
    }
    cancelCardModal()
  }

  // const handleCtaToggle = (event) => {
  //   let { checked } = event.target
  //   setCtaButton({ enabled: checked, text: '', link: { type: '', data: {} } })
  // }
  const onPositionChange = (event) => {
    let { value, checked } = event.target
    if (checked) {
      setContent((prevContent) => ({ ...prevContent, position: value }))
    }
  }
  // const onCtaButtonPositionChange = (event) => {
  //   let { value } = event.target
  //   setCtaButton((prevContent) => ({ ...prevContent, position: value }))
  // }

  let accordionItems = [
    {
      title: 'Add Image',
      description:
        'Specify the image which you would like to display in the slides of the banner section of the template.',
      children: (
        <div
          style={{ backgroundColor: '#e5e5e5' }}
          className=" px-4 py-3 d-flex flex-column justify-content-center align-items-center"
        >
          <ImageUploader data={imageData} />
          <span className="mt-2" style={{ fontSize: '11px', color: '#707070' }}>
            Image should be of 1920 px X 802px and 3 MB size.
          </span>
          <div className="message-text error-message">
            <p>{errorData.imageS3key}</p>
          </div>
        </div>
      ),
      itemStyle: '',
    },
    {
      title: 'Add Text',
      description:
        'Specify the text and position which you would like to display in the slides of the banner section.',
      children: (
        <div style={{ backgroundColor: '#e5e5e5' }} className=" px-4 py-3">
          <div className="">
            <h6 style={{ fontSize: '13px' }} className="">
              Heading
            </h6>
            <CustomDescriptionBox
              limit={80}
              rows={1}
              value={content.heading}
              onChange={(value) =>
                setContent((prevContent) => ({ ...prevContent, heading: value }))
              }
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
            />
          </div>
          <div className="mt-1">
            <h6 style={{ fontSize: '13px' }}>Sub-heading</h6>
            <CustomDescriptionBox
              limit={200}
              rows={3}
              value={content.sub_heading}
              onChange={(value) =>
                setContent((prevContent) => ({ ...prevContent, sub_heading: value }))
              }
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
            />
          </div>
          <div className="mt-1">
            <h6 style={{ fontSize: '13px' }}>Set Position</h6>
            <CTable
              style={{ fontSize: '12px', width: '284px', marginBottom: 0, textAlign: 'center' }}
              className="py-2"
              // striped
              bordered
              borderColor="white"
            >
              <CTableHead>
                <CTableRow>
                  <CTableDataCell
                    style={{ backgroundColor: '#ccc', width: '28%' }}
                  ></CTableDataCell>
                  <CTableDataCell style={{ backgroundColor: '#ccc', width: '24%' }}>
                    Left
                  </CTableDataCell>
                  <CTableDataCell style={{ backgroundColor: '#ccc', width: '24%' }}>
                    Center
                  </CTableDataCell>
                  <CTableDataCell style={{ backgroundColor: '#ccc', width: '24%' }}>
                    Right
                  </CTableDataCell>
                </CTableRow>
              </CTableHead>
              <CTableBody className="">
                <CTableRow>
                  <CTableDataCell style={{ backgroundColor: '#ccc' }} align="middle">
                    Top
                  </CTableDataCell>
                  <CTableDataCell style={{ backgroundColor: '#fff' }} align="middle">
                    <CFormCheck
                      onChange={(e) => onPositionChange(e)}
                      inline
                      type="radio"
                      id="TOP_LEFT"
                      value="TOP_LEFT"
                      label=""
                      checked={content.position === 'TOP_LEFT'}
                    />
                  </CTableDataCell>
                  <CTableDataCell style={{ backgroundColor: '#fff' }} align="middle">
                    <CFormCheck
                      onChange={(e) => onPositionChange(e)}
                      inline
                      type="radio"
                      id="TOP_CENTER"
                      value="TOP_CENTER"
                      label=""
                      checked={content.position === 'TOP_CENTER'}
                    />
                  </CTableDataCell>
                  <CTableDataCell style={{ backgroundColor: '#fff' }} align="middle">
                    <CFormCheck
                      onChange={(e) => onPositionChange(e)}
                      inline
                      type="radio"
                      id="TOP_RIGHT"
                      value="TOP_RIGHT"
                      label=""
                      checked={content.position === 'TOP_RIGHT'}
                    />
                  </CTableDataCell>
                </CTableRow>
                <CTableRow>
                  <CTableDataCell style={{ backgroundColor: '#ccc' }} align="middle">
                    Center
                  </CTableDataCell>
                  <CTableDataCell style={{ backgroundColor: '#ebebeb' }} align="middle">
                    <CFormCheck
                      onChange={(e) => onPositionChange(e)}
                      inline
                      type="radio"
                      id="CENTER_LEFT"
                      value="CENTER_LEFT"
                      label=""
                      checked={content.position === 'CENTER_LEFT'}
                    />
                  </CTableDataCell>
                  <CTableDataCell style={{ backgroundColor: '#ebebeb' }} align="middle">
                    <CFormCheck
                      onChange={(e) => onPositionChange(e)}
                      inline
                      type="radio"
                      id="CENTER"
                      value="CENTER"
                      label=""
                      checked={content.position === 'CENTER'}
                    />
                  </CTableDataCell>
                  <CTableDataCell style={{ backgroundColor: '#ebebeb' }} align="middle">
                    <CFormCheck
                      onChange={(e) => onPositionChange(e)}
                      inline
                      type="radio"
                      id="CENTER_RIGHT"
                      value="CENTER_RIGHT"
                      label=""
                      checked={content.position === 'CENTER_RIGHT'}
                    />
                  </CTableDataCell>
                </CTableRow>
                <CTableRow>
                  <CTableDataCell style={{ backgroundColor: '#ccc' }} align="middle">
                    Bottom
                  </CTableDataCell>
                  <CTableDataCell style={{ backgroundColor: '#fff' }} align="middle">
                    <CFormCheck
                      onChange={(e) => onPositionChange(e)}
                      inline
                      type="radio"
                      id="BOTTOM_LEFT"
                      value="BOTTOM_LEFT"
                      label=""
                      checked={content.position === 'BOTTOM_LEFT'}
                    />
                  </CTableDataCell>
                  <CTableDataCell style={{ backgroundColor: '#fff' }} align="middle">
                    <CFormCheck
                      onChange={(e) => onPositionChange(e)}
                      inline
                      type="radio"
                      id="BOTTOM_CENTER"
                      value="BOTTOM_CENTER"
                      label=""
                      checked={content.position === 'BOTTOM_CENTER'}
                    />
                  </CTableDataCell>
                  <CTableDataCell style={{ backgroundColor: '#fff' }} align="middle">
                    <CFormCheck
                      onChange={(e) => onPositionChange(e)}
                      inline
                      type="radio"
                      id="BOTTOM_RIGHT"
                      value="BOTTOM_RIGHT"
                      label=""
                      checked={content.position === 'BOTTOM_RIGHT'}
                    />
                  </CTableDataCell>
                </CTableRow>
              </CTableBody>
            </CTable>
          </div>
        </div>
      ),
      itemStyle: 'mt-4',
    },
    {
      title: 'Add Navigation Link',
      description:
        'Specify the link to which you would like to redirect after clicking the banner of the template.',
      children: (
        <div style={{ backgroundColor: '#e5e5e5' }} className="px-4 py-3">
          <AttachLink
            title=""
            linkData={link}
            id={'ctaButton'}
            categoryData={
              categoryList
                ? categoryList?.data.filter((info, idx) => info.type === 'category' && info.status)
                : []
            }
            setLinkData={(value) => {
              clearError('ctaButtonLink')
              setLink(value)
            }}
          />
          <div className="message-text error-message">
            <p>{errorData?.link}</p>
          </div>
        </div>
      ),
      itemStyle: 'mt-4',
    },
    {
      title: 'Add CTA Button',
      description:
        'Specify the button text and position which you would like to display in the slides of the banner section.',
      children: (
        <div style={{ backgroundColor: '#e5e5e5' }} className="px-4 py-3">
          <div className="d-flex justify-content-between">
            <h6 style={{ fontSize: '13px', color: `${!ctaButton.enabled ? '#918b8b' : 'black'}` }}>
              Button Text
            </h6>
            {/* <div className="flex">
                <span style={{ fontSize: '13px' }} className="mx-2">
                  Add CTA Button
                </span>
                <CFormSwitch
                  label=""
                  id="buttonEnable"
                  checked={ctaButton.enabled}
                  valid={ctaButton.enabled}
                  onChange={(e) => handleCtaToggle(e)}
                />
              </div> */}
          </div>
          <CustomDescriptionBox
            limit={15}
            rows={1}
            value={ctaButton.text}
            onChange={(value) => setCtaButton((prev) => ({ ...prev, text: value }))}
            style={{ fontSize: '12px' }}
            limitFontSize={'11px'}
            isMandatory={ctaButton.enabled}
            errorText={errorData?.ctaButtonText}
          />
        </div>
      ),
      itemStyle: 'mt-4',
      enableSwitch: true,
      switchChecked: ctaButton.enabled,
      switchToggle: (event) => {
        let { checked } = event.target
        setCtaButton({ enabled: checked, text: '' })
      },
    },
  ]
  return (
    <CModal size="lg" className="" visible={true}>
      <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
      <CModalHeader style={{ borderBottom: 0 }} className="d-flex justify-content-center mt-3">
        <p style={{ fontSize: '1.5rem' }}>
          <b style={{ fontWeight: '500' }}>Single Banner Editor</b>
        </p>
      </CModalHeader>
      <CModalBody
        style={{ minHeight: '75vh' }}
        className=" static-scrollbar-class d-flex flex-column justify-content-between"
      >
        <div className="d-flex justify-content-center">
          <div
            style={{ width: '82%' }}
            className="flex flex-column justify-content-center align-items-center"
          >
            <TemplateAccordion items={accordionItems} styles={''} />
          </div>
        </div>
      </CModalBody>
      <CModalFooter style={{ borderTop: 0 }} className="">
        <div style={{ marginRight: '9%' }} className="pb-3">
          <CButton
            style={{ color: 'black', border: '1px solid black', fontSize: '1.1rem' }}
            className="mx-4 bg-white rounded-1 btn-focus-none"
            onClick={() => {
              cancelCardModal()
            }}
          >
            Cancel
          </CButton>
          <CButton
            style={{ fontSize: '1.1rem' }}
            className=" bg-black rounded-1 btn-focus-none px-3"
            onClick={() => {
              handleSave()
            }}
          >
            Save
          </CButton>
        </div>
      </CModalFooter>
    </CModal>
  )
}

export default FitnessHeroCardModal
